export const REMOTION_PLAYER_FPS = 30;
export const INTRO_OUTRO_DEFAULT_DURATION = 3;
export const MAX_PERSONAL_VIDEO_DURATION = 30;
export const DEFAULT_CLIP_DURATION = 5;
export const DEFAULT_TEXT_DURATION = 5;
export const DEFAULT_TRANSITION_DURATION = 2;
export const MARGIN_SCALING = 25;
export const FONT_SIZE_SCALING = 12;
export const MAX_VIDEO_PERSONAL_ASSET_DURATION = 30;
export const BASIC_MOVEMENT_BUNDLE_SCALING = 0.9;
export const DEFAULT_TEXT_START_TIME = 2;
export const DEFAULT_TEXT_START_FROM_END_TIME = 3;
export const FADE_IN_AND_OUT_EFFECT = 2;
export const MOVE_IMAGE_EFFECT = 3;
export const SCALE_IMAGE_EFFECT_DEFAULT = 4;
export const SCALE_IMAGE_EFFECT_ZOOM = 3;
export const IMAGE_BARS_PERCENTAGE = 0.03;
export const REMOTION_PREFETCHING = 'prefetchingAssets';
